@if (pagedTickets$ | glxyAsyncStatus | async; as ticketList) {
  <div class="ticket-list">
    @switch (ticketList.status) {
      @case ('loading') {
        <glxy-loading-spinner></glxy-loading-spinner>
      }
      @case ('error') {
        <glxy-alert type="warning">
          {{ 'INBOX.TICKETS.ERROR_TICKETS' | translate: { status: statusName } }}
        </glxy-alert>
      }
      @case ('loaded') {
        @if (isLoading$ | async) {
          <glxy-loading-spinner></glxy-loading-spinner>
        }
        @if ((isLoading$ | async) === false) {
          <glxy-label class="ticket-type">{{ title }} ({{ ticketList.value.total }})</glxy-label>
          @if (ticketList.value.total === 0) {
            <mat-card class="ticket-card" appearance="outlined">
              <mat-card-content>
                <mat-card-subtitle>
                  {{ 'INBOX.TICKETS.NO_TICKETS' | translate: { status: statusName } }}
                </mat-card-subtitle>
              </mat-card-content>
            </mat-card>
          }
          @if (ticketList.value.total > 0) {
            @for (ticketInfo of ticketList.value.tickets; track ticketInfo) {
              <div class="ticket-card">
                <inbox-ticket-card [ticketCardInfo]="ticketInfo"></inbox-ticket-card>
              </div>
            }
          }
          @if (ticketList.value.continue) {
            <div class="button-more">
              <a (click)="loadClosed()">{{ 'INBOX.TICKETS.LOAD_MORE' | translate }}</a>
            </div>
          }
        }
      }
    }
  </div>
}
